/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MOTOLYNK MARKET API
 * Admin, vendor and store APIs of the MOTOLYNK multi-vendor marketplace.
 * OpenAPI spec version: 1.0.0
 */
import { BlankEnum } from './blankEnum';
import { FuelTypeEnum } from './fuelTypeEnum';

export const VariantFuelType = {...FuelTypeEnum,...BlankEnum,} as const